import $ from 'jquery';

$('.js-navi').each(function () {
	$(this).clone().addClass('is-clone').appendTo(this);
});

$(window)
	.scroll(function () {
		var scrollDistance = $(window).scrollTop();
		var offsetTop = $('.c-header').outerHeight();
		var anchorBar = $('.js-navi.is-clone').outerHeight() + 1;

		if ($('.js-navi').length > 0) {
			if (scrollDistance > $('.js-navi').position().top) {
				$('.js-navi.is-clone').addClass('is-show');
			} else {
				$('.js-navi.is-clone').removeClass('is-show');
			}

			$('.jsAnchor').each(function () {
				var el = $(this),
					className = el.attr('id');
				if (el.offset().top - anchorBar < scrollDistance) {
					$('.c-navi__item').removeClass('is-active');
					$(`.c-navi__txt[href='#${className}']`)
						.parent()
						.addClass('is-active');
				} else {
				}
			});
		}
	})
	.scroll();

$(window).on('scroll', function () {
	$('.js-navi').css('left', -$(window).scrollLeft());
});
